import { render, staticRenderFns } from "./ShapeSettings.vue?vue&type=template&id=8d603ae0"
import script from "./ShapeSettings.vue?vue&type=script&lang=js"
export * from "./ShapeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports